export const Services = () => {
  return (
    <div className="container" style={{ paddingTop: '24px' }}>
      <h1>Услуги</h1>
      <p>Список услуг агентства...</p>
    </div>
  );
};